import * as _4 from 'lodash4';

enum cancelledStatus {
  CANCELLED = 'cancelled'
}

interface IAppointmentRequest {
  id: number;
  end_time: string;
  start_time: string;
  campaign_note: string;
  total_uses: number;
  remaining_uses: number;
  creator: ICreator;
  services: IService[];
  location: Location;
  staff: IService[];
  course?: string;
  cancellation_lead_time_hours?: number;
  will_be_no_show?: boolean;
  meeting_url_or_phone?: string;
}

interface ILocation {
  id?: any;
  name: string;
}

interface IService {
  id: string;
  name: string;
}

interface ICreator {
  id: number;
  name: string;
}

interface IAppointmentDetails {
  attendees: IAttendee[];
  can_cancel: boolean;
  comments: string;
  details: string;
  end_time: string;
  end_ts: string;
  event_id: number;
  id: string;
  instance_id: number;
  location: string;
  name: string;
  recurrs: boolean;
  staff: IStaff[];
  start_time: string;
  start_ts: string;
  status: string;
  student_services: any[];
  course?: string;
  cancellation_lead_time_hours?: number;
  will_be_no_show?: boolean;
  meeting_url_or_phone?: string;
}

interface IStaff {
  id: string;
  name: string;
}

interface IAttendee {
  id: number;
  name: string;
}

export class AppointmentPathItemFn {
  constructor() {}
  generateAppointmentDetails(appointmentDetails: IAppointmentDetails) {
    return {
      end_timestamp: moment(appointmentDetails.end_time).unix(),
      attendees: appointmentDetails.attendees,
      start_timestamp: moment(appointmentDetails.start_time).unix(),
      organizers: this._organizerDetails(appointmentDetails.staff),
      student_services: _4.map(_4.split(appointmentDetails.name), (service: any, key: number) => ({
        id: key,
        name: service
      })),
      location: { id: -1, name: appointmentDetails.location },
      additional_details: _4.get(appointmentDetails, 'details', ''),
      comments: appointmentDetails.comments,
      is_cancelled: this._isCancelled(_4.get(appointmentDetails, 'status', '')),
      student_can_cancel: appointmentDetails.can_cancel,
      appointment_type: this._appointmentType(_4.get(appointmentDetails, 'recurrs', false)),
      calendar_instance_id: appointmentDetails.instance_id,
      cancellation_lead_time_hours: appointmentDetails.cancellation_lead_time_hours,
      will_be_no_show: appointmentDetails.will_be_no_show,
      course: appointmentDetails.course,
      meeting_url_or_phone: appointmentDetails.meeting_url_or_phone
    };
  }
  private _organizerDetails(organizers: IStaff[]) {
    return _4.map(organizers, (organizer: IStaff, key: number) => ({
      id: _4.get(organizer, 'id', key),
      first_name: organizer.name,
      last_name: _4.get(organizer, 'last_name', '')
    }));
  }
  private _isCancelled(status: string) {
    return _4.lowerCase(status) === cancelledStatus.CANCELLED;
  }
  private _appointmentType(isRecurring: boolean) {
    return isRecurring ? 'Recurring Appointment' : 'One Time Appointment';
  }
  generateAppointmentRequestDetails(appointmentRequest: IAppointmentRequest) {
    return {
      id: appointmentRequest.id,
      campaign_note: appointmentRequest.campaign_note,
      appointments_scheduled_so_far: appointmentRequest.total_uses,
      remaining_appointments_for_student: appointmentRequest.remaining_uses,
      creator: { id: appointmentRequest.creator.id, first_name: appointmentRequest.creator.name, last_name: '' },
      end_date: appointmentRequest.end_time,
      start_date: appointmentRequest.start_time,
      appointment_type: _4.get(appointmentRequest, 'type', ''),
      student_service: _4.head(appointmentRequest.services),
      service_category: null,
      location: appointmentRequest.location,
      organizers: _4.map(appointmentRequest.staff, (staff: any) => ({
        id: staff.id,
        first_name: staff.name,
        last_name: ''
      })),
      cancellation_lead_time_hours: appointmentRequest.cancellation_lead_time_hours,
      will_be_no_show: appointmentRequest.will_be_no_show,
      course: appointmentRequest.course,
      meeting_url_or_phone: appointmentRequest.meeting_url_or_phone
    };
  }
}
angular.module('data-ng-path-item').service('appointmentPathItemFn', AppointmentPathItemFn);



// WEBPACK FOOTER //
// ./app/vendor/data-ng-path-item/src/functions/appointment_path_item_fn.ts